"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDateToTimeZone = exports.checkDateTimeFormat = void 0;

var convertDateToTimeZone = function convertDateToTimeZone(date, timezone) {
  var convertedDateTime = date.toLocaleString('en-US', {
    timeZone: timezone
  });
  return new Date(convertedDateTime);
};

exports.convertDateToTimeZone = convertDateToTimeZone;

var formatDateTime = function formatDateTime(input, separator) {
  var dateArr = input.split(separator);

  if (dateArr.length === 0) {
    return input;
  }

  var formattedArr = [];
  dateArr.forEach(function (date) {
    formattedArr.push(date < 10 && !date.includes('0') ? "0".concat(date) : date);
  });
  return formattedArr.join(separator);
};

function isIsoDate(str) {
  var pattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
  if (!pattern.test(str)) return false;
  return str;
}

var checkDateTimeFormat = function checkDateTimeFormat(dateTime) {
  if (isIsoDate(dateTime)) {
    var getDateInput = dateTime.split('T');

    if (getDateInput.length === 0) {
      return dateTime;
    }

    var formattedDate = formatDateTime(getDateInput[0], '-');
    var formattedTime = formatDateTime(getDateInput[1], ':');
    return "".concat(formattedDate, "T").concat(formattedTime);
  }

  return null;
};

exports.checkDateTimeFormat = checkDateTimeFormat;